import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-navIcon1",
  "use": "icon-navIcon1-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-navIcon1\"><path fill-rule=\"evenodd\" d=\"M10.69 3.647a1 1 0 0 0-1.38 0L4.273 8.46c-.652.623-.211 1.723.69 1.723h.528v5.448a1 1 0 0 0 1 1h1.175a1 1 0 0 0 1-1v-2a1.333 1.333 0 0 1 2.666 0v2a1 1 0 0 0 1 1h1.176a1 1 0 0 0 1-1v-5.448h.526c.902 0 1.343-1.1.69-1.723z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol